import axios from "axios"
import { CCTextarea } from "../commonComponents/inputFields"
import { useState } from "react"
import { CcLoader } from "../commonComponents/generalComponents"

export const AITimerTemplateEditor = (props) => {
  const [history, setHistory] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [currentQuestion, setCurrentQuestion] = useState('')
  const [placeholder, setPlaceholder] = useState('Ask for your edits...')

  const handleUserQuestion = (text) => {
      setCurrentQuestion('')
      setPlaceholder('')
      getUpdatedStyle(text)
  }

  const getUpdatedStyle = async (text) => {
      const currentHistory = [...history]
      setHistory([...currentHistory, {text: text, user: true}])
    try {
      setIsLoading(true)
      let url = `${process.env.REACT_APP_LION_API_URL}/AIEditors/templates/timer/`;
      let response = await axios.post(url, {query: text});

      const data = response.data
      if (props.onChange) props.onChange(JSON.parse(data.body).settings)
      //updating history
      setHistory([...currentHistory, {text: text, user: true}, {text: data.responseMessage, textItems: data.responseMessageItems, user: false}])

              
    } catch (error) {
      console.log(error);
    }
    finally {setIsLoading(false)}

  
  }


  return <div className="font-poppins text-black">
            <div className="my-2">Tell me how you would like your timer template to be styled.</div>
            <div className="flex flex-col gap-y-4 mb-3 h-56 overflow-auto text-sm">
              {history.map(msg => {if (msg.user) return <>
                                                          <div className='rounded px-2 py-1 bg-slate-100 w-[80%]' >{msg.text}</div>
                                                        </>
                                  else return <div className="flex flex-row">
                                                <div className="flex grow"></div>
                                                <div className='rounded px-2 py-1 bg-blue-100 w-[80%]' >
                                                  <div>{msg.text}</div>
                                                  <ul className="list-disc ml-4">
                                                  {msg.textItems.map(item => <li>{item}</li>)}
                                                  </ul>
                                                  </div>
                                              </div>})}
            </div>
          {isLoading && <div className="flex flex-row items-center gap-x-1 text-slate-400 mb-1">
            <CcLoader size={18} />
            <div className="text-sm">Thinking...</div>
            </div>}
          <CCTextarea onChange={handleUserQuestion} onInputChange={setCurrentQuestion}
          value={currentQuestion}
           label="" placeholder={placeholder} />
  </div>

}